import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/fr";
import "element-ui/lib/theme-chalk/index.css";
import Vue from "vue";
import VueKonva from "vue-konva";
import VueTouch from "vue-touch";
import Vuex from "vuex";
import App from "./App.vue";
import router from "./router/index.js";
import configStore from "./store";

VueTouch.config.pan = {
	direction: "horizontal",
};

Vue.config.productionTip = false;

Vue.use(ElementUI, { locale });
Vue.use(VueKonva);
Vue.use(VueTouch, { name: "v-touch" });
Vue.use(Vuex);

Vue.config.devtools = true;

const store = new Vuex.Store(configStore);

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
